export const getAppHeaderOffset = () => {
  if (typeof document === "undefined") {
    return 0;
  }

  const headerStack = document.querySelector(".app-header-stack");

  return headerStack ? headerStack.offsetHeight : 0;
};
